<template>
  <v-container fluid style="overflow: hidden !important;" class="CSChatThai">
    <v-layout row wrap v-if="status_login === 'T'" class="hidden-sm-and-down">
      <v-flex sm12 md12 lg12 xl12 v-if="progress">
        <v-layout row wrap justify-center align-center class="height-100vh">
          <v-progress-circular :size="100" :indeterminate="progress" color="primary"></v-progress-circular>
        </v-layout>
      </v-flex>
      <v-flex sm12 md12 lg12 xl12 v-else>
        <v-content>
          <v-container fluid fill-height>
            <v-layout justify-center class="chatboxnonselect" column>
              <v-stepper v-model="stepSelect" vertical>
                <v-layout row wrap class="ml-4 mt-3">
                  <strong style="font-size:20px;">{{$t('Task.allTask.createProject')}}</strong>
                </v-layout>
                <v-stepper-step :complete="stepSelect > 1" step="1">
                  {{$t('Task.create.placeholderSubjectProject')}}
                </v-stepper-step>

                <v-stepper-content step="1">
                  <v-layout column justify-center class="mt-2">
                    <template>
                      <v-flex class="layoutfield">
                        <v-text-field
                          name="projectname"
                          :label="$t('Task.create.placeholderSubjectProject')"
                          id="id"
                          v-model="project_name"
                          solo
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="layoutfield">
                        <v-textarea
                          :label="$t('Task.create.description')"
                          name="descriptionproject"
                          no-resize
                          solo
                          v-model="detail_project"
                          :rules="[(v) => v.length <= 250 || '']"
                          :counter="250"
                        ></v-textarea>
                      </v-flex>
                    </template>
                  </v-layout>
                  <v-layout row wrap justify-end align-end>
                    <template>
                      <v-btn class="btnclear" @click="cancel_project()">{{$t('AnswerQuestion.clear')}}</v-btn>
                      <v-btn class="btncancle" outline @click="stepSelect = 2"
                      :disabled="project_name == ''">{{$t('Task.allTask.next')}}</v-btn>
                    </template>
                  </v-layout>
                </v-stepper-content>

                <v-stepper-step :complete="stepSelect > 2" step="2">
                  {{$t('Task.create.select')}}
                </v-stepper-step>

                <v-stepper-content step="2">
                  <v-layout row wrap class="mt-0">
                    <v-flex sm12 md12 xl12 lg12>
                      <v-tabs left color="white" dark icons-and-text v-model="tabs" class="mt-2">
                        <v-tabs-slider color="#232b35"></v-tabs-slider>

                        <v-tab :key="1" href='#tab-1'>
                          <p style="color: #232b35; text-transform: none;">{{$t('LeftSide.friend.friend')}}</p>
                          <v-icon color="#232b35">fas fa-user</v-icon>
                        </v-tab>

                        <v-tab :key="2" href='#tab-2'>
                          <p style="color: #232b35; text-transform: none;">{{$t('LeftSide.friend.group')}}</p>
                          <v-icon color="#232b35">fas fa-users</v-icon>
                        </v-tab>
                        <v-tabs-items>
                          <v-tab-item id="tab-1">
                            <v-flex xs12 sm12 md12 xl12 lg12 v-if="listfriend.length != 0">
                              <v-card class="card-tabs">
                                <v-container style="min-height: 0; height: calc(100vh - 430px) !important;" class="scrolling-wrapper">
                                  <v-layout justify-center row >
                                    <div class="listFrinend" >
                                      <v-layout row wrap>
                                        <template v-for="(item, index) in FilterListFriend">
                                          <v-flex xs12 sm4 md4 xl4 lg4 :key="index">
                                            <v-card class="cardOfFriendList" @click.native="radios=item.tokenroom">
                                              <v-layout align-center justify-center row wrap>
                                                <v-flex md4 sm12 xs12 d-flex>
                                                  <v-avatar
                                                    style="margin-top: 5px;"
                                                    size="45px"
                                                  >
                                                    <img :src="item.profilepicture" class="object-fit-img" v-if="item.profilepicture">
                                                    <img src="/static/img/default_profile/man-white.png" class="object-fit-img" v-else-if="item.type == 'user'">
                                                    <img src="/static/img/default_profile/bot-white.png" class="object-fit-img" v-else-if="item.type == 'bot'">
                                                    <img src="/static/img/default_profile/business-white.png" class="object-fit-img" v-else-if="item.type == 'business'">
                                                    <img src="/static/img/default_profile/man-white.png" class="object-fit-img" v-else>
                                                  </v-avatar>
                                                </v-flex>
                                                <v-flex md6 sm12 xs12 d-flex>
                                                  <strong style="margin-bottom:20px; margin-top:20px; font-size:13px;" class="textWrap">{{ item.name }}</strong>
                                                </v-flex>
                                                <v-flex md2 d-flex>
                                                  <v-radio-group style="margin-bottom:20px;" v-model="radios" :mandatory="false">
                                                    <v-radio :value="item.tokenroom" class="radioPosition"></v-radio>
                                                  </v-radio-group>
                                                </v-flex>
                                              </v-layout>
                                            </v-card>
                                          </v-flex>
                                        </template>
                                      </v-layout>
                                    </div>
                                  </v-layout>
                                </v-container>
                              </v-card>
                            </v-flex>
                            <v-flex xs12 sm12 md12 xl12 lg12 v-else class="flex-center cal-height-100vh">
                              <v-layout column wrap justify-center align-center>
                                <v-icon style="font-size: 60px !important;">fas fa-user-friends</v-icon>
                                <h4 class="mt-3">{{$t('Task.allTask.noListFriend')}}</h4>
                              </v-layout>
                            </v-flex>
                          </v-tab-item>

                          <v-tab-item id="tab-2">
                            <v-flex xs12 sm12 md12 xl12 lg12 v-if="listgroup.length != 0">
                              <v-card class="card-tabs">
                                <v-container style="min-height: 0; height: calc(100vh - 430px) !important;" class="scrolling-wrapper">
                                  <v-layout justify-center row >
                                    <div class="listFrinend" >
                                      <v-layout row wrap>
                                        <template v-for="(item, index) in FilterListGroup">
                                          <v-flex xs12 sm4 md4 xl4 lg4 :key="index">
                                            <v-card class="cardOfFriendList" @click.native="radios=item.tokenroom">
                                              <v-layout align-center justify-center row wrap>
                                                <v-flex md4 sm12 xs12 d-flex>
                                                  <v-avatar  style="margin-top: 5px;" size="45px">
                                                    <img :src="item.picture" class="object-fit-img" v-if="item.picture">
                                                    <img src="/static/img/default_profile/group-white.png" class="object-fit-img" v-else>
                                                  </v-avatar>
                                                </v-flex>
                                                <v-flex md6 sm12 xs12 d-flex>
                                                  <strong style="margin-bottom:20px; margin-top:20px; font-size:16px;" class="textWrap" >{{ item.name }}</strong>
                                                </v-flex>
                                                <v-flex md2 d-flex>
                                                  <v-radio-group style="margin-bottom:20px;" v-model="radios" :mandatory="false">
                                                    <v-radio :value="item.tokenroom" class="radioPosition"></v-radio>
                                                  </v-radio-group>
                                                </v-flex>
                                              </v-layout>
                                            </v-card>
                                          </v-flex>
                                        </template>
                                      </v-layout>
                                    </div>
                                  </v-layout>
                                </v-container>
                              </v-card>
                            </v-flex>
                            <v-flex xs12 sm12 md12 xl12 lg12 v-else class="flex-center mt-3 cal-height-100vh">
                              <v-layout column wrap justify-center align-center>
                                <v-icon style="font-size: 60px !important;">fas fa-users</v-icon>
                                <h4 class="mt-3">{{$t('Task.allTask.noListGroup')}}</h4>
                              </v-layout>
                            </v-flex>
                          </v-tab-item>
                        </v-tabs-items>
                        <v-layout row wrap align-center justify-end class="ml-1 mr-5 bg-white" v-if="tabs == 'tab-1'">
                          <v-flex xs2 sm2 md2 lg2 xl2 class="mt-2 mr-4" v-if="listfriend.length == 0">
                            <v-btn class="btncreate" @click="open_add_friend()">{{$t('LeftSide.friend.addFriend')}}</v-btn>
                          </v-flex>
                          <v-flex sm5 md5 lg5 xl5 class="ml-3 mt-3" v-else>
                            <v-text-field
                              v-model="search"
                              solo
                              :label="$t('Task.allTask.placeholderSearchFriend')"
                              clearable
                              append-icon="search"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap align-center justify-end class="ml-1 mr-5 bg-white" v-else>
                          <!-- <v-flex xs2 sm2 md2 lg2 xl2 class="mt-2 mr-4"> -->
                            <v-btn class="btncreate" @click="open_create_group()">{{$t('Task.allTask.newGroup')}}</v-btn>
                          <!-- </v-flex> -->
                          <v-flex sm5 md5 lg5 xl5 class="ml-3 mt-3" v-if="listgroup.length !== 0">
                            <v-text-field
                              v-model="search_group"
                              solo
                              :label="$t('Task.allTask.placeholderSearchGroup')"
                              clearable
                              append-icon="search"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-tabs>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="mt-2">
                    <v-flex class="text-xs-left">
                      <template>
                        <v-btn outline class="btncancle" @click="stepSelect = 1">{{$t('Register.Button.back')}}</v-btn>
                      </template>
                    </v-flex>
                    <v-flex class="text-xs-right">
                      <v-btn style="margin-right: 60px;" class="btnclear" @click="cancel_radios()">{{$t('AnswerQuestion.clear')}}</v-btn>
                      <v-btn class="btncreate" @click="create_project = 'isloading'" :loading="isloading"
                      :disabled="project_name == '' || radios == ''">{{$t('AnswerQuestion.ok')}}</v-btn>
                    </v-flex>
                  </v-layout>
                </v-stepper-content>
              </v-stepper>
              <!-- <v-layout row wrap>
                <v-flex sm12 md12 lg12 xl12>
                </v-flex>
              </v-layout> -->
              <!-- <v-layout row wrap class="mt-0">
                <v-flex sm12 md12 xl12 lg12>
                <v-tabs left color="white" dark icons-and-text v-model="tabs" class="mt-2">
                  <v-tabs-slider color="#232b35"></v-tabs-slider>

                  <v-tab :key="1" href='#tab-1'>
                    <p style="color: #232b35; text-transform: none;">{{$t('LeftSide.friend.friend')}}</p>
                    <v-icon color="#232b35">fas fa-user</v-icon>
                  </v-tab>

                  <v-tab :key="2" href='#tab-2'>
                    <p style="color: #232b35; text-transform: none;">{{$t('LeftSide.friend.group')}}</p>
                    <v-icon color="#232b35">fas fa-users</v-icon>
                  </v-tab>
                  <v-tabs-items>
                    <v-tab-item id="tab-1">
                      <v-layout column justify-center class="mt-2 ml-5 mr-5" v-if="listfriend.length != 0">
                        <div class="tooltip text-xs-center" style="cursor: pointer;" @click="showtextCreateProject = true">
                          <v-icon small color="#232b35" v-if="showtextCreateProject !== true" style="cursor: pointer; margin-right: 10px;">fas fa-angle-double-down</v-icon>
                          <span class="tooltiptext" style="margin-top: 10px;">{{$t('Task.allTask.createProject')}}</span>
                        </div>
                        <template v-if="showtextCreateProject !== false">
                          <v-flex class="layoutfield">
                            <v-text-field
                              name="projectname"
                              :label="$t('Task.create.placeholderSubjectProject')"
                              id="id"
                              v-model="project_name"
                              solo
                            ></v-text-field>
                          </v-flex>
                          <v-flex class="layoutfield">
                            <v-textarea
                              :label="$t('Task.create.description')"
                              name="descriptionproject"
                              no-resize
                              solo
                              v-model="detail_project"
                              :rules="[(v) => v.length <= 250 || '']"
                              :counter="250"
                            ></v-textarea>
                          </v-flex>
                        </template>
                      </v-layout>
                      <v-layout row wrap justify-center align-center v-if="listfriend.length != 0">
                        <template v-if="showtextCreateProject !== false">
                          <v-btn class="btncancle" @click="cancel_project()">{{$t('AnswerQuestion.cancel')}}</v-btn>
                          <v-btn class="btncreate" @click="created_project()" :loading="isloading"
                          :disabled="project_name == '' || radios == '' || detail_project.length > 250">{{$t('AnswerQuestion.ok')}}</v-btn>
                        </template>
                      </v-layout>
                      <v-layout row wrap justify-center align-center v-if="listfriend.length != 0">
                        <v-icon small class="justify-center" color="#232b35" v-if="showtextCreateProject !== false"  @click="showtextCreateProject = false" style="cursor: pointer; margin-top: 10px; margin-right: 10px;">fas fa-angle-double-up</v-icon>
                      </v-layout>
                      <v-flex xs12 sm12 md12 xl12 lg12 v-if="listfriend.length != 0">
                        <v-card class="card-tabs" v-if="showtextCreateProject !== true">
                          <v-container style="min-height: 0; height: calc(100vh - 220px) !important;" class="scrolling-wrapper">
                            <v-layout justify-center row >
                              <div class="listFrinend" >
                                <v-layout row wrap>
                                  <template v-for="(item, index) in FilterListFriend">
                                    <v-flex xs12 sm4 md4 xl4 lg4 :key="index">
                                      <v-card class="cardOfFriendList" @click.native="radios=item.tokenroom">
                                        <v-layout align-center justify-center row wrap>
                                          <v-flex md4 sm12 xs12 d-flex>
                                            <v-avatar
                                              style="margin-top: 5px;"
                                              size="45px"
                                            >
                                              <img :src="item.profilepicture" class="object-fit-img" v-if="item.profilepicture">
                                              <img src="/static/img/default_profile/man-white.png" class="object-fit-img" v-else-if="item.type == 'user'">
                                              <img src="/static/img/default_profile/bot-white.png" class="object-fit-img" v-else-if="item.type == 'bot'">
                                              <img src="/static/img/default_profile/business-white.png" class="object-fit-img" v-else-if="item.type == 'business'">
                                              <img src="/static/img/default_profile/man-white.png" class="object-fit-img" v-else>
                                            </v-avatar>
                                          </v-flex>
                                          <v-flex md6 sm12 xs12 d-flex>
                                            <strong style="margin-bottom:20px; margin-top:20px; font-size:13px;" class="textWrap">{{ item.name }}</strong>
                                          </v-flex>
                                          <v-flex md2 d-flex>
                                            <v-radio-group style="margin-bottom:20px;" v-model="radios" :mandatory="false">
                                              <v-radio :value="item.tokenroom" class="radioPosition"></v-radio>
                                            </v-radio-group>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-flex>
                                  </template>
                                </v-layout>
                              </div>
                            </v-layout>
                          </v-container>
                        </v-card>
                        <v-card class="card-tabs" v-else>
                          <v-container style="min-height: 0; height: calc(100vh - 540px) !important;" class="scrolling-wrapper">
                            <v-layout justify-center row >
                              <div class="listFrinend" >
                                <v-layout row wrap>
                                  <template v-for="(item, index) in FilterListFriend">
                                    <v-flex xs12 sm4 md4 xl4 lg4 :key="index">
                                      <v-card class="cardOfFriendList" @click.native="radios=item.tokenroom">
                                        <v-layout align-center justify-center row wrap>
                                          <v-flex md4 sm12 xs12 d-flex>
                                            <v-avatar
                                              style="margin-top: 5px;"
                                              size="45px"
                                            >
                                              <img :src="item.profilepicture" class="object-fit-img" v-if="item.profilepicture">
                                              <img src="/static/img/default_profile/man-white.png" class="object-fit-img" v-else-if="item.type == 'user'">
                                              <img src="/static/img/default_profile/bot-white.png" class="object-fit-img" v-else-if="item.type == 'bot'">
                                              <img src="/static/img/default_profile/business-white.png" class="object-fit-img" v-else-if="item.type == 'business'">
                                              <img src="/static/img/default_profile/man-white.png" class="object-fit-img" v-else>
                                            </v-avatar>
                                          </v-flex>
                                          <v-flex md6 sm12 xs12 d-flex>
                                            <strong style="margin-bottom:20px; margin-top:20px; font-size:13px;" class="textWrap">{{ item.name }}</strong>
                                          </v-flex>
                                          <v-flex md2 d-flex>
                                            <v-radio-group style="margin-bottom:20px;" v-model="radios" :mandatory="false">
                                              <v-radio :value="item.tokenroom" class="radioPosition"></v-radio>
                                            </v-radio-group>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-flex>
                                  </template>
                                </v-layout>
                              </div>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm12 md12 xl12 lg12 v-else class="flex-center cal-height-100vh">
                        <v-layout column wrap justify-center align-center>
                          <v-icon style="font-size: 60px !important;">fas fa-user-friends</v-icon>
                          <h4 class="mt-3">{{$t('Task.allTask.noListFriend')}}</h4>
                        </v-layout>
                      </v-flex>
                  </v-tab-item>

                    <v-tab-item id="tab-2">
                      <v-layout column justify-center class="mt-2 mr-5 ml-5" v-if="listgroup.length != 0">
                        <div class="tooltip text-xs-center" style="cursor: pointer;" @click="showtextCreateProject = true">
                          <v-icon small color="#232b35" v-if="showtextCreateProject !== true" style="cursor: pointer; margin-right: 10px;">fas fa-angle-double-down</v-icon>
                          <span class="tooltiptext" style="margin-top: 10px;">{{$t('Task.allTask.createProject')}}</span>
                        </div>
                        <template v-if="showtextCreateProject !== false">
                          <v-flex class="layoutfield">
                            <v-text-field
                              name="projectname"
                              :label="$t('Task.create.placeholderSubjectProject')"
                              id="id"
                              v-model="project_name"
                              solo
                            ></v-text-field>
                          </v-flex>
                          <v-flex class="layoutfield">
                            <v-textarea
                              :label="$t('Task.create.description')"
                              name="descriptionproject"
                              no-resize
                              solo
                              v-model="detail_project"
                              :rules="[(v) => v.length <= 250 || '']"
                              :counter="250"
                            ></v-textarea>
                          </v-flex>
                        </template>
                      </v-layout>
                      <v-layout row wrap justify-center align-center v-if="listgroup.length != 0">
                        <template v-if="showtextCreateProject !== false">
                          <v-btn class="btncancle" @click="cancel_project()">{{$t('AnswerQuestion.cancel')}}</v-btn>
                          <v-btn class="btncreate" @click="created_project()" :loading="isloading"
                            :disabled="project_name == '' || radios == '' || detail_project.length > 250">{{$t('AnswerQuestion.ok')}}</v-btn>
                        </template>
                      </v-layout>
                      <v-layout row wrap justify-center align-center v-if="listgroup.length != 0">
                        <v-icon small class="justify-center" color="#232b35" v-if="showtextCreateProject !== false"  @click="showtextCreateProject = false" style="cursor: pointer; margin-top: 10px; margin-right: 10px;">fas fa-angle-double-up</v-icon>
                      </v-layout>
                      <v-flex xs12 sm12 md12 xl12 lg12 v-if="listgroup.length != 0">
                        <v-card class="card-tabs" v-if="showtextCreateProject !== true">
                          <v-container style="min-height: 0; height: calc(100vh - 220px) !important;" class="scrolling-wrapper">
                            <v-layout justify-center row >
                              <div class="listFrinend" >
                                <v-layout row wrap>
                                  <template v-for="(item, index) in FilterListGroup">
                                    <v-flex xs12 sm4 md4 xl4 lg4 :key="index">
                                      <v-card class="cardOfFriendList" @click.native="radios=item.tokenroom">
                                        <v-layout align-center justify-center row wrap>
                                          <v-flex md4 sm12 xs12 d-flex>
                                            <v-avatar  style="margin-top: 5px;" size="45px">
                                              <img :src="item.picture" class="object-fit-img" v-if="item.picture">
                                              <img src="/static/img/default_profile/group-white.png" class="object-fit-img" v-else>
                                            </v-avatar>
                                          </v-flex>
                                          <v-flex md6 sm12 xs12 d-flex>
                                            <strong style="margin-bottom:20px; margin-top:20px; font-size:16px;" class="textWrap" >{{ item.name }}</strong>
                                          </v-flex>
                                          <v-flex md2 d-flex>
                                            <v-radio-group style="margin-bottom:20px;" v-model="radios" :mandatory="false">
                                              <v-radio :value="item.tokenroom" class="radioPosition"></v-radio>
                                            </v-radio-group>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-flex>
                                  </template>
                                </v-layout>
                              </div>
                            </v-layout>
                          </v-container>
                        </v-card>
                        <v-card class="card-tabs" v-else-if="showtextCreateProject !== false">
                          <v-container style="min-height: 0; height: calc(100vh - 540px) !important;" class="scrolling-wrapper">
                            <v-layout justify-center row >
                              <div class="listFrinend" >
                                <v-layout row wrap>
                                  <template v-for="(item, index) in FilterListGroup">
                                    <v-flex xs12 sm4 md4 xl4 lg4 :key="index">
                                      <v-card class="cardOfFriendList" @click.native="radios=item.tokenroom">
                                        <v-layout align-center justify-center row wrap>
                                          <v-flex md4 sm12 xs12 d-flex>
                                            <v-avatar  style="margin-top: 5px;" size="45px">
                                              <img :src="item.picture" class="object-fit-img" v-if="item.picture">
                                              <img src="/static/img/default_profile/group-white.png" class="object-fit-img" v-else>
                                            </v-avatar>
                                          </v-flex>
                                          <v-flex md6 sm12 xs12 d-flex>
                                            <strong style="margin-bottom:20px; margin-top:20px; font-size:16px;" class="textWrap" >{{ item.name }}</strong>
                                          </v-flex>
                                          <v-flex md2 d-flex>
                                            <v-radio-group style="margin-bottom:20px;" v-model="radios" :mandatory="false">
                                              <v-radio :value="item.tokenroom" class="radioPosition"></v-radio>
                                            </v-radio-group>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-flex>
                                  </template>
                                </v-layout>
                              </div>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm12 md12 xl12 lg12 v-else class="flex-center mt-3 cal-height-100vh">
                        <v-layout column wrap justify-center align-center>
                          <v-icon style="font-size: 60px !important;">fas fa-users</v-icon>
                          <h4 class="mt-3">{{$t('Task.allTask.noListGroup')}}</h4>
                        </v-layout>
                      </v-flex>
                    </v-tab-item>
                  </v-tabs-items>
                  <v-layout row wrap align-center justify-end class="ml-1 mr-5 bg-white" v-if="tabs == 'tab-1'">
                    <v-flex xs2 sm2 md2 lg2 xl2 class="mt-2 mr-4" v-if="listfriend.length == 0">
                      <v-btn class="btncreate" @click="open_add_friend()">{{$t('LeftSide.friend.addFriend')}}</v-btn>
                    </v-flex>
                    <v-flex sm5 md5 lg5 xl5 class="ml-3 mt-3" v-else>
                      <v-text-field
                        v-model="search"
                        solo
                        :label="$t('Task.allTask.placeholderSearchFriend')"
                        clearable
                        append-icon="search"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap align-center justify-end class="ml-1 mr-5 bg-white" v-else>
                    <v-btn class="btncreate" @click="open_create_group()">{{$t('Task.allTask.newGroup')}}</v-btn>
                    <v-flex sm5 md5 lg5 xl5 class="ml-3 mt-3" v-if="listgroup.length !== 0">
                      <v-text-field
                        v-model="search_group"
                        solo
                        :label="$t('Task.allTask.placeholderSearchGroup')"
                        clearable
                        append-icon="search"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-tabs>
                </v-flex>
              </v-layout> -->
            </v-layout>
          </v-container>
        </v-content>
      </v-flex>
    </v-layout>
    <CreateProject :dialogCreateProject="dialogCreateProject" @closeCreateProject="closeCreateProject" :projectid="projectid" @createdproject="createdproject"></CreateProject>
    <CreateGroupDialog :dialogGroup="CreateGroup" @closeDialogCreateGroup="closeDialogCreateGroup" @updatecreategroup="updatecreategroup"></CreateGroupDialog>
    <AddDialog :dialogAdd="AddFriend" @closeDialogAddFriend="closeDialogAddFriend" @blockevent="blockevent"></AddDialog>
  </v-container>
</template>

<script>
import { sync } from 'vuex-pathify'
import { Decode, Momenttime } from '@/services'
import Rightside from '@/components/chat/layout/RightSide'
import CreateProject from '@/components/chat/manage_task/created_project_dialog'
import CreateGroupDialog from '@/components/chat/dialog/manage_group/CreateGroupDialog'
import AddDialog from '@/components/chat/dialog/manage_friend/AddFriendDialog'

var _ = require('lodash')
export default {
  // props: {
  //   source: String
  // },
  components: {
    Rightside,
    CreateProject,
    CreateGroupDialog,
    AddDialog
  },
  data () {
    return {
      AddFriend: false,
      radios: '',
      tabs: '',
      text: 'mm',
      listproject: [],
      dialogDetailTask: false,
      dialogCreateProject: false,
      status_login: '',
      windowWidth: '',
      mini: true,
      dialog: false,
      drawer: true,
      detail: {},
      token: '',
      detail_project: {},
      progress: false,
      projectid: '',
      state_id: '',
      member: [],
      taskid: '',
      search: '',
      search_group: '',
      listproject_user: [],
      listproject_group: [],
      listfriend: [],
      listgroup: [],
      project_name: '',
      detail_project: '',
      isloading: false,
      CreateGroup: false,
      showtextCreateProject: true,
      stepSelect: 1,
      create_project: null,
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.status_login = decoded['status_login']
    // this.get_project_room()
    this.get_list_friend()
    this.get_list_group()
  },
  computed: {
    ...sync('*'),
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    FilterListFriend () {
      if (this.search !== '' && this.search !== null) {
        return this.listfriend.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listfriend
      }
    },
    FilterListGroup () {
      if (this.search_group !== '' && this.search_group !== null) {
        return this.listgroup.filter(post => {
          return post.name.toLowerCase().includes(this.search_group.toLowerCase())
        })
      } else {
        return this.listgroup
      }
    }
  },
  watch: {
    windowWidth () {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage')
      }
    },
    socketmessage (data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        if (data.message == 'create_task') {
          this.get_task_by_id(data.task_id, data.state.state_id, 'create')
        }
      }
    },
    create_project () {
      const l = this.create_project
      this[l] = true
      this.axios.post(process.env.APIpub + '/v1/user/create_project', {
        tokenuser: this.token,
        tokenroom: this.radios,
        project_name: this.project_name,
        detail: this.detail_project
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data.data)
          this[l] = false
          this.cancel_project()
          this.$swal('', this.$t('Alert.Success.createProject'), 'success')
          this.projectid = response.data.data._id
          this.$router.push('/chat/task/' + this.projectid + '/' + response.data.data.tokenroom)
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    socket_deletetask (data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.axios.post(process.env.APIpub + '/v1/user/get_project_by_id', {
          tokenuser: this.token,
          tokenroom: this.$route.params.roomid,
          project_id: this.projectid
        }).then((responsed) => {
          // console.log(responsed.data.data)
          if (responsed.data.status == 'success') {
            this.detail_project = responsed.data.data
          }
        })
      }
    },
    socket_edittask (data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.axios.post(process.env.APIpub + '/v1/user/get_task_by_id', {
          tokenuser: this.token,
          task_id: data.task_id
        }).then((responsed) => {
          if (responsed.data.status == 'success') {
            // console.log(responsed.data.data)
            var new_state = responsed.data.data.state.id
            var old_index = ''
            var index_member = ''
            var index = ''
            old_index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == data.state_id.id })
            index_member = _.findIndex(this.detail_project.state[old_index].member, function(o) { return o._id == data.task_id })
            index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == new_state })
            this.detail_project.state[old_index].member.splice(index_member, 1)
            this.detail_project.state[index].member.unshift(responsed.data.data)
          }
        })
      }
    },
    socketaccept_friend (data) {
      var tokenfriend = data.tokenfriend
      this.axios.post(process.env.APImanage + '/searchtokenuser', {tokenuser: this.token, tokenfriend: tokenfriend}).then((response) => {
        if (_.find(this.listfriend, function (o) { return o.tokenuser === response.data.user.tokenuser }) === undefined) {
          this.listfriend.unshift(response.data.user)
          this.radios = ''
        }
      })
    },
    socketremove_friend (data) {
      // console.log(data)
      var index = _.findIndex(this.listfriend, function (o) { return o.tokenroom === data.tokenroom })
      if (index >= 0) {
        this.listfriend.splice(index, 1)
      }
    },
    block_friend (data) {
      this.blockevent(data)
    }
  },
  methods: {
    blockevent (data) {
      // console.log(data)
      if (data.event === 'unblock_friend') {
        this.listfriend.push(data)
      }
    },
    open_add_friend () {
      this.AddFriend = true
    },
    open_create_group () {
      this.CreateGroup = true
    },
    closeDialogCreateGroup (value) {
      this.CreateGroup = value
    },
    closeDialogAddFriend (value) {
      this.AddFriend = value
    },
    updatecreategroup (data, filename) {
      if (_.find(this.listgroup, function (o) { return o.group_id === data.group_id }) === undefined) {
        this.listgroup.unshift({
          count_read: '',
          create_date: data.create_date,
          group_id: data.group_id,
          member: data.member,
          name: data.name,
          picture: filename,
          state: data.state,
          timestamp: data.timestamp,
          tokenroom: data.tokenroom,
          type: data.type
        })
        this.listgroup = _.reverse(_.sortBy(this.listgroup, function (dateObj) {
          return new Date(dateObj.create_date)
        }))
      }
    },
    cancel_project () {
      this.project_name = ''
      this.detail_project = ''
      // this.radios = ''
    },
    cancel_radios () {
      this.radios = ''
    },
    get_list_friend () {
      this.progress = true
      this.axios.post(process.env.APImanage + '/web/getlistfriend', {
        tokenuser: this.token
      }).then((response) => {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.listfriend = response.data['listfriend']
          // console.log(this.listfriend)
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    get_list_group () {
      this.progress = true
      this.axios.post(process.env.APImanage + '/web/getlistgroup2', {
        tokenuser: this.token
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.listgroup = response.data['listgroup']
          // console.log(this.listgroup)
          this.listgroup = _.reverse(_.sortBy(this.listgroup, function (dateObj) {
            return new Date(dateObj.create_date)
          }))
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    topage_task (projectid, tokenroom) {
      // console.log(projectid)
      this.$router.push('/chat/task/' + projectid + '/' + tokenroom)
    },
    momentday (timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    createdproject (value) {
      this.get_project_by_id(value.project_id, value.event)
    },
    closeCreateProject (value) {
      this.dialogCreateProject = value
    },
    edittask (data) {
      // console.log(data)
      this.get_task_by_id(data.task_id, data.state_id, data.event, data.old_state)
    },
    deletetask (data) {
      // console.log(data)
      var index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == data.state_id })
      var index_member = _.findIndex(this.detail_project.state[index].member, function(o) { return o._id == data.task_id })
      this.detail_project.state[index].member.splice(index_member, 1)
    },
    closeDetailTask(value) {
      this.dialogDetailTask = value
    },
    open_create_project () {
      this.dialogCreateProject = true
    },
    open_detail_task (taskid) {
      this.taskid = taskid
      // console.log(this.StateId)
      this.dialogDetailTask = true
    },
    toChatroom () {
      // this.$router.push('/chat/room/' + this.$route.params.roomid)
      this.$router.go(-1)
    },
    get_data_room () {
      this.detail = {}
      this.progress = true
      this.axios.post(process.env.APImanage + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.detail = response.data
          // console.log(this.detail)
          var member = []
          member = response.data.data_room
          this.member = _.filter(member, function(o) { return o.statemember == 'active' })
          // this.check_project_room()
        }
      })
    },
    get_project_room () {
      this.progress = true
      this.axios.post(process.env.APIpub + '/v1/user/get_project_by_tokenuser', {
        tokenuser: this.token
      }).then((response) => {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.listproject = response.data.data
          this.listproject = _.reverse(_.sortBy(this.listproject, function (dateObj) {
            return new Date(dateObj.timestamp)
          }))
          this.listproject_group = _.filter(this.listproject, function(o) { return o.tokenroom.startsWith('G') })
          this.listproject_user = _.filter(this.listproject, function(o) { return o.tokenroom.startsWith('R') })
          // console.log(this.listproject_group)
          // console.log(this.listproject_user)
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    // created_project () {
    //   this.isLoading = true
    //   this.axios.post(process.env.APIpub + '/v1/user/create_project', {
    //     tokenuser: this.token,
    //     tokenroom: this.radios,
    //     project_name: this.project_name,
    //     detail: this.detail_project
    //   }).then((response) => {
    //     if (response.data.status === 'success') {
    //       // console.log(response.data.data)
    //       this.isLoading = false
    //       this.cancel_project()
    //       this.$swal('', this.$t('Alert.Success.createProject'), 'success')
    //       this.projectid = response.data.data._id
    //       this.$router.push('/chat/task/' + this.projectid + '/' + response.data.data.tokenroom)
    //     }
    //   }).catch(error => {
    //     console.log(error.message)
    //   })
    // },
    get_project_by_id (projectid, events) {
      this.axios.post(process.env.APIpub + '/v1/user/get_project_by_id', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_id: projectid
      }).then((responsed) => {
        // console.log(responsed.data.data)
        if (responsed.data.status == 'success') {
          if (events == 'create_project') {
            this.listproject.unshift(responsed.data.data)
          }
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    get_task_by_id (taskid, stateid, stateevent, oldstate) {
      this.axios.post(process.env.APIpub + '/v1/user/get_task_by_id', {
        tokenuser: this.token,
        task_id: taskid
      }).then((responsed) => {
        if (responsed.data.status == 'success') {
          // console.log(responsed.data.data)
          var old_index = ''
          var index_member = ''
          var index = ''
          if (stateevent == 'edit') {
            old_index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == oldstate })
            index_member = _.findIndex(this.detail_project.state[old_index].member, function(o) { return o._id == taskid })
            index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == stateid })
            this.detail_project.state[old_index].member.splice(index_member, 1)
            this.detail_project.state[index].member.unshift(responsed.data.data)
            // console.log(this.detail_project.state[index].member)
          } else if (stateevent == 'create') {
            index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == stateid })
            this.detail_project.state[index].member.unshift(responsed.data.data)
          }
        }
      })
    },
    TestClick () {
      console.log('eeeeeeeeeeeee')
    }
  }
}
</script>
<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.height-100vh {
  height: 100vh !important
}
.cal-height-100vh {
  height: calc(100vh - 128px) !important;
}
.flex-center {
  justify-content: center !important;
  align-items: center !important;
  display: flex !important;
}
.btnclear {
  font-weight: 700;
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 15px!important;
  background-image: linear-gradient(to right, #9f9f9f, #9f9f9f) !important;
  color: white !important;
  width: 120px !important;
  text-transform: none;
}
.btncreate {
  font-weight: 700;
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 15px!important;
  background-image: linear-gradient(to right, rgb(66, 104, 251), rgb(113, 186, 200)) !important;
  color: white !important;
  width: 120px !important;
  text-transform: none;
}
.btncancle {
  font-weight: bold;
  border-width: 2px;
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 10px !important;
  /* background: #ffffff !important; */
  color: #4268fb !important;
  width: 120px !important;
  border-style: solid !important;
  /* border-color: #4268fb !important; */
  box-shadow: none !important;
  text-transform: none;
}
/* >>>.v-text-field__details {
  display: none !important;
  flex: 1 0 auto !important;
  max-width: 100% !important;
  overflow: hidden !important;
} */
>>>.v-list {
  width: 100% !important;
}
.bg-white {
  background-color: white !important;
}
.card-tabs {
  background-color: rgb(253, 253, 253) !important;
  border-radius: 10px !important;
  /* margin-left: 80px !important;
  margin-right: 80px !important; */
  border-style: solid !important;
  border-color: #f1f1f2 !important;
  border-width: thin !important;
  margin-top: 30px !important;
}
.text-overflow-project {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.span-detail-project {
  color: #8e8e92 !important;
  margin-left: 20px !important;
}
.card-project {
  border-radius: 10px !important;
  background-color: white !important;
  /* border-color: #dadada !important; */
  border-style: solid !important;
  border-width: thin !important;
  height: 150px !important;
  cursor: pointer !important;
}
.card-project:hover {
  border-radius: 10px !important;
  background-color: rgba(234, 234, 234, 0.23137254901960785) !important;
  border-color: rgba(234, 234, 234, 0.23137254901960785) !important;
  border-style: solid !important;
  border-width: thin !important;
  height: 150px !important;
  cursor: pointer !important;
}
.span-timestamp {
  font-size: 14px !important;
  color: grey !important;
}
>>>.v-list {
    /* min-width: 210px !important; */
    max-width: 100% !important;
}
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
.text-transform {
  /* text-transform: uppercase; */
  text-transform: capitalize !important;
}
.btn-plus-user {
  background-color: #efefef !important;
  color: #1d1d1d !important;
  box-shadow: none !important;
}
.font-size18 {
  font-size: 18px !important;
}
.font-title-task {
  font-size: 19px !important;
  font-weight: 500 !important;
}
/* >>>.v-list__tile .theme--light {
  height: 200px !important;
} */
/* >>>.v-navigation-drawer .v-list .v-list__tile {
  height: 200px !important;
  transition: none !important;
  font-weight: 500 !important;
} */
.card-task-pri1 {
  background-color: white !important;
  color: black !important;
  border-style: solid !important;
  border-radius: 10px !important;
  border-width: thin !important;
  /* margin-bottom: 15px; */
  /* border-color: #1b232d; */
  margin-top: 10px !important;
  margin-left: 5px !important;
  margin-right: 5px !important;
  border-left-color: #b3493d !important;
  border-left-width: 12px !important;
  /* border-left-style: solid; */
  height: 100px !important;
  cursor: pointer !important;
}
.card-task-pri2 {
  background-color: white !important;
  color: black !important;
  border-style: solid !important;
  border-radius: 10px !important;
  border-width: thin !important;
  /* margin-bottom: 15px; */
  /* border-color: #1b232d; */
  margin-top: 10px !important;
  margin-left: 5px !important;
  margin-right: 5px !important;
  border-left-color: #fcbe55 !important;
  border-left-width: 12px !important;
  /* border-left-style: solid; */
  height: 100px !important;
  cursor: pointer !important;
}
.card-task-pri3 {
  background-color: white !important;
  color: black !important;
  border-style: solid !important;
  border-radius: 10px !important;
  border-width: thin !important;
  /* margin-bottom: 15px; */
  /* border-color: #1b232d; */
  margin-top: 10px !important;
  margin-left: 5px !important;
  margin-right: 5px !important;
  border-left-color: #a0a1a3 !important;
  border-left-width: 12px !important;
  /* border-left-style: solid; */
  height: 100px !important;
  cursor: pointer !important;
}
.overflow-scroll {
  overflow-y: scroll !important;
}
.object-fit-img {
  object-fit: cover;
  object-position: 50% 0;
  margin-bottom: 10px;
}
.border-img {
  border-color: grey !important;
  border-style: solid !important;
  border-width: thin !important;
}
.margin-top-120px {
  margin-top: 120px !important;
}
.text-overflow {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 250px !important;
  text-align: center !important;
}
.text-overflow-groupname {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 180px !important;
  /* text-align: center !important; */
}
.text-overflow-list {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 190px !important;
}
.color-white {
  color: white !important;
}
/* >>>.v-list__tile__content {
  height: 70vh;
  margin-top: 50px;
} */
.height-200px {
  height: 200px !important;
}
.height-300px {
  height: 300px !important;
}
.width-100 {
  width: 100% !important;
}
.color-card-task {
  overflow: scroll !important;
  height: 60vh !important;
  margin-top: 20px !important;
  border-radius: 6px !important;
  background-color: #f1f1f1 !important;
}
.system-bar {
  height: 4px !important;
  background-color: #e0e0e0 !important;
  border-radius: 10px !important;
  /* margin-left: 18px !important; */
}
.font-size-16 {
  font-size: 16px !important;
}
.ml-50 {
  margin-left: 50px !important;
}
.span-clear-filter {
   color: #949494 !important;
   font-size: 16px !important;
}
>>>.v-input__slot {
  border-radius: 13px !important;
  box-shadow: none !important;
  /* background-color: rgba(142, 142, 147, 0.12156862745098039) !important; */
}
>>>.v-text-field>.v-input__control>.v-input__slot {
  cursor: text !important;
  transition: background .3s cubic-bezier(.25,.8,.5,1) !important;
  background-color: rgba(92, 92, 95, 0.122) !important;
}

>>>.v-text-field.v-text-field--solo .v-label {
  font-size: 14px;
}

>>>.theme--dark.v-label {
    color: rgba(0,0,0,.54) !important;
}
>>>.theme--dark.v-icon {
    color: rgb(35, 43, 53) !important;
}
>>>.theme--dark.v-input:not(.v-input--is-disabled) input {
    color: rgba(0,0,0,.54) !important;
}
.btn-filter-task {
  border-radius: 6px !important;
  border: solid 1px #2562af !important;
  color: #2562af !important;
  background-color: white !important;
  box-shadow: none !important;
}
.icon-filter-task {
  color: #2562af !important;
  font-size: 16px !important;
}
.icon-create-task{
  color: white !important;
  font-size: 16px !important;
}
.btn-create-task {
  background-color: #2561b0 !important;
  /* border-color: #2561b0 !important; */
  border-style: solid !important;
  border-radius: 6px !important;
  color: white !important;
  box-shadow: none !important;
}
.btn-nav {
  background-color: #d8d8d8 !important;
}
>>>.v-list .v-list--dense .theme--light {
  margin-top: 70px !important;
}
.bg-flex-1 {
  background-color: #1b232d;
}
.container{
  padding: 0px !important;
}
.fixed-content {
  min-height:100%;
  /*position:fixed;*/
  overflow-y:scroll;
  overflow-x:hidden;
}
.content {
  padding: 0px 0px 0px !important;
}
>>>.chatboxnonselect {
  width: 100%;
  min-width: 10vw;
  height: calc(100vh - 64px);
  background-color:white;
  overflow-y: hidden;
}
.btn-color {
  background-color: white !important;
  border-color: #2561b0 !important;
  border-style: solid !important;
  border-radius: 6px !important;
  color: #2561b0 !important;
  box-shadow: none !important;
}
.icon-color {
  color: #2561b0 !important;
}
>>> .theme--light.v-card {
    background-color: #fff;
    border-color: none !important;
    color: rgba(0,0,0,.87);
}
/*  */
.List{
  margin-left: 20px;
  margin-right: 20px;
  /* border: brown solid 2px !important; */
  /* background-color:#d3d5da62; */
}

.List:hover{
  margin-left: 0px;
  margin-right: 0px;
  border-left-style: solid;
  border-left-width:10px;
  border-left-color: coral;
  /* border-style:inset; */
}

.listFrinend{
  width: 100%;
  height: 80%;
  background-color: transparent;
  color: white;
}

.cardOfFriendList{
  margin: 20px 20px 20px 20px;
  border-radius: 10px;
  /* background-color: #AC8887 !important; */
  border: #92ADCF solid 2px !important;
  cursor: pointer;
}

.cardOfFriendList:hover{
  box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
}
.radioPosition{
  position: absolute;
  /* object-position: 50% 0; */
}
.test{
  box-shadow: 0 3px 2px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
.grouplist:hover .overlay{
  opacity: 0.5;
}
.overlay{
  position: absolute; 
  bottom: 0; 
  background: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.5); /* Black see-through */
  color: #f1f1f1; 
  width: 100%;
  transition: .5s ease;
  opacity:0;
  color: white;
  /* font-size: 20px; */
  padding: 20px;
  text-align: center;
}
.containOverlay{
  position: relative;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: .5s ease;
  /* border-radius: 50%; */
  background-color: #0000004141;
}

.containOverlay:hover .overlay {
  opacity: 1;
  cursor: pointer;
}

.textOverlay{
  color: white;
  /* font-size: 20px; */
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}
.textWrap{
  white-space: nowrap;
  width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  /* text-align: center; */
}

.tooltip {
  position: relative;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-image: linear-gradient(to right, rgb(66, 104, 251), rgb(113, 186, 200)) !important;
  color: white !important;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50%;
  margin-left: -60px;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

/* .layoutfield {
  margin-left: 140px;
  margin-right: 140px;
} */

</style>



// WEBPACK FOOTER //
// src/components/chat/manage_task/homepage_created_project.vue